import $ from 'jquery'

export default {
    name: 'registre-biochimie',
    components: {},
    props: [],
    data () {
        return {
            liste_parametre_analyse: []     //  Liste des parametre analyse
        }
    },
    computed: {

    },
    mounted () {
        setTimeout(() => {
        $('.shw').fadeIn()
        }, 500);

        this.liste_parametre_analyse = [
            "Gly", "Urée", "Créat", "AU",
            "O", "P", "&#947;", "PAL", "BD",
            "BT", "CH-T", "TG", "HDL", "LDL",
            "Ca<sup>2+</sup>", "Mg<sup>2+</sup>",
            "Phos", "Na", "K", "Cl"
        ]
    },
    methods: {

    }
}


